<template>
  <div :class="`md-layout-item md-size-${size} md-small-size-${size*2} md-xsmall-size-50`">
    <label>{{label}}</label>
    <p :class="copy ? 'copy-text' : ''" @click="copy ? copyText(value) : ''">{{value}}</p>
  </div>
</template>

<script>
export default {
  name: "Field",

  props: {
    label: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 25,
    },
    copy: {
      type: Boolean,
      default: false,
    },
    value: {
      required: true,
    },
  },

  data() {
    return {};
  },
  methods: {
    copyText(text) {
      navigator.clipboard.writeText(text);
    },
  },
};
</script>

<style lang="css" scoped>
.copy-text:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/File/FField.vue